"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPublicRealEstate = exports.getPublicRealEstates = exports.deleteRealEstateRelation = exports.postRealEstateRelation = exports.putRealEstateOrganization = exports.putRealEstateAccessibility = exports.deleteRealEstatePermission = exports.postRealEstatePermission = exports.postRealEstate = exports.putRealEstate = exports.getRealEstate = exports.getRealEstates = void 0;

var common_1 = require("../common");

var root_1 = require("./root");

var realEstatesAuthorizedPath = root_1.propertyManagementAuthorized + '/realestates/';
var realEstatesPublicPath = root_1.propertyManagementPublic + '/realestates/';

var getRealEstates = function getRealEstates(authentication, queryParameters) {
  return common_1.get(authentication, realEstatesAuthorizedPath, queryParameters);
};

exports.getRealEstates = getRealEstates;

var getRealEstate = function getRealEstate(authentication, id) {
  return common_1.get(authentication, realEstatesAuthorizedPath + id);
};

exports.getRealEstate = getRealEstate;

var putRealEstate = function putRealEstate(authentication, realestate) {
  return common_1.put(authentication, realEstatesAuthorizedPath + realestate.id, realestate);
};

exports.putRealEstate = putRealEstate;

var postRealEstate = function postRealEstate(authentication, realestate) {
  return common_1.post(authentication, realEstatesAuthorizedPath, realestate);
};

exports.postRealEstate = postRealEstate;

var postRealEstatePermission = function postRealEstatePermission(authentication, id, permission) {
  return common_1.postPermission(authentication, realEstatesAuthorizedPath, id, permission);
};

exports.postRealEstatePermission = postRealEstatePermission;

var deleteRealEstatePermission = function deleteRealEstatePermission(authentication, id, permissionId) {
  return common_1.deletePermission(authentication, realEstatesAuthorizedPath, id, permissionId);
};

exports.deleteRealEstatePermission = deleteRealEstatePermission;

var putRealEstateAccessibility = function putRealEstateAccessibility(authentication, id, accessibility) {
  return common_1.putAccessibility(authentication, realEstatesAuthorizedPath, id, accessibility);
};

exports.putRealEstateAccessibility = putRealEstateAccessibility;

var putRealEstateOrganization = function putRealEstateOrganization(authentication, id, accessibility) {
  return common_1.putEntityOrganization(authentication, realEstatesAuthorizedPath, id, accessibility);
};

exports.putRealEstateOrganization = putRealEstateOrganization;

var postRealEstateRelation = function postRealEstateRelation(authentication, id, relation) {
  return common_1.postRelation(authentication, realEstatesAuthorizedPath, id, relation);
};

exports.postRealEstateRelation = postRealEstateRelation;

var deleteRealEstateRelation = function deleteRealEstateRelation(authentication, id, relationId) {
  return common_1.deleteRelation(authentication, realEstatesAuthorizedPath, id, relationId);
};

exports.deleteRealEstateRelation = deleteRealEstateRelation;

var getPublicRealEstates = function getPublicRealEstates(authentication, queryParameters) {
  return common_1.get(authentication, realEstatesPublicPath, queryParameters);
};

exports.getPublicRealEstates = getPublicRealEstates;

var getPublicRealEstate = function getPublicRealEstate(authentication, id) {
  return common_1.get(authentication, realEstatesPublicPath + id);
};

exports.getPublicRealEstate = getPublicRealEstate;